import type { RailLayout } from "@/data/rail-branches";
import type { CharacterMarker, SceneBeat } from "@/lib/timeline/book/BookLayout";
import type { SceneMotionFrame } from "@/lib/timeline/scene/SceneMotion/motion";
import type { MarkerPose, MarkerTrack } from "../MarkerTrack/track";

export const BOARD_REFERENCE_VIEWPORT_WIDTH = 1200;
export const BOARD_REFERENCE_STAGE_HEIGHT = 800;

export interface CastCharacter {
  characterId: string;
  displayName: string;
  imageUrl?: string;
  appearances: CharacterMarker["appearances"];
}

export interface CharacterMarkerOnBoard {
  id: string;
  characterId: string;
  groupId: string;
  track: MarkerTrack;
}

export interface CharacterMarkerGroup {
  id: string;
  branchId: string;
  placeId: string;
  placeLabel?: string;
  markerIds: string[];
}

export interface LocationSiteMarker {
  id: string;
  siteLabel: string;
  track: MarkerTrack;
}

export interface LocationPartMarker {
  id: string;
  placeId: string;
  partLabel: string;
  track: MarkerTrack;
}

export interface LocationMarkerGroup {
  id: string;
  branchId: string;
  site: LocationSiteMarker;
  parts: LocationPartMarker[];
}

export interface ChapterBoard {
  bookId: string;
  chapterId: string;
  title: string;
  totalDurationMs: number;
  beats: SceneBeat[];
  rail: RailLayout;
  cast: CastCharacter[];
  characterMarkers: CharacterMarkerOnBoard[];
  characterGroups: CharacterMarkerGroup[];
  locationGroups: LocationMarkerGroup[];
  referenceViewportWidth: number;
}

export interface SampledCharacterMarker {
  characterId: string;
  groupId: string;
  /** Waiting ahead on the timeline, so the camera does not frame it. */
  parked?: boolean;
  pose: MarkerPose;
}

export interface SampledLocationPart {
  placeId: string;
  partLabel: string;
  pose: MarkerPose;
}

export interface SampledLocationGroup {
  branchId: string;
  siteLabel: string;
  sitePose: MarkerPose;
  parts: SampledLocationPart[];
}

export interface BoardSample {
  playheadMs: number;
  motion: SceneMotionFrame;
  characters: SampledCharacterMarker[];
  locationGroups: SampledLocationGroup[];
}
